import cards from '../response/cards/get.json';
// Card details
import activeCard from '../response/cards/card-detail/active.json';
import closedCard from '../response/cards/card-detail/closed.json';
import damagedCard from '../response/cards/card-detail/damaged.json';
import inactiveCard from '../response/cards/card-detail/inactive.json';
import lostCard from '../response/cards/card-detail/lost.json';
import processingCard from '../response/cards/card-detail/processing.json';
import requestedInErrorCard from '../response/cards/card-detail/requested-in-error.json';
import stolenCard from '../response/cards/card-detail/stolen.json';

import resetPinSuccess from '../response/cards/reset-pin-success.json';
import cardEdit from '../response/cards/card-edit.json';
import cardsStatusUpdate from '../response/cards/card-status-update.json';
import cardsPendingTransfers from '../response/cards/cards-pending-transfers.json';
// import cardSearch from '../response/cards/card-search.json';
import cashSearch from '../response/cash/cash-search.json';

// Account defaults
import cardAccountDefaults from '../response/cards/account-defaults/card-account-default.json';
import rsaNc from '../response/cards/account-defaults/rsa-NC.json';
import rsaT from '../response/cards/account-defaults/rsa-T.json';
import rsaYa from '../response/cards/account-defaults/rsa-YA.json';
import snrNc from '../response/cards/account-defaults/snr-NC.json';
import snrY from '../response/cards/account-defaults/snr-Y.json';
import snrYa from '../response/cards/account-defaults/snr-YA.json';
import snrYc from '../response/cards/account-defaults/snr-YC.json';
import rsaSnrNc from '../response/cards/account-defaults/rsa-snr-NC.json';
import { Response } from 'miragejs';

export default function CardRoutes() {
  // Get Cards
  this.get('/cards-api/v1/cards/contract/:id', () => {
    return cards;
  });

  // Get Card Detail
  this.get('/cards-api/v1/cards/:cardId/detail', (schema, request) => {
    const { cardId: cardNumber } = request.params;

    if (cardNumber === '7071340000010032') return processingCard;
    if (cardNumber === '7071340000010594') return damagedCard;
    if (cardNumber === '7071340000009992') return lostCard;
    if (cardNumber === '7071340000010586') return stolenCard;
    if (cardNumber === '7071340000010610') return requestedInErrorCard;
    if (cardNumber === '7071340000010628') return closedCard;
    if (cardNumber === '7071340000010636') return inactiveCard;

    return activeCard;
  });

  // Get card account defaults
  this.get('/cards-api/v1/cards/contract/:accountId/default', (schema, request) => {
    const { contractNumber } = request.queryParams;

    if (contractNumber === '0600008503') return rsaNc;
    if (contractNumber === '0600008461') return rsaT;
    if (contractNumber === '0600008357') return rsaYa;
    if (contractNumber === '0600008321') return snrNc;
    if (contractNumber === '0600008291') return snrY;
    if (contractNumber === '0600008278') return snrYa;
    if (contractNumber === '0600008242') return snrYc;
    if (contractNumber === '0600008308') return rsaSnrNc;

    return cardAccountDefaults;
  });

  // Get pending transfers (Cards > Pending Transfers)
  this.get('/cards-api/v1/cards/transfer/pending', (schema, request) => {
    const { contractIdentifier } = request.queryParams;

    return contractIdentifier === '0600008503' ? cardsPendingTransfers : {
      'result': [],
      'resultSize': 0,
    };
  });

  // Activate Single Card
  this.post('/cards-api/v1/cards/activate/:cardNumber', () => {
  });

  // Activate Multiple Cards
  this.post('/cards-api/v1/cards/activate', () => {
    return new Response(200, {}, { status: 'Activation succeeded.' });
  });

  // Update PIN
  this.post('/cards-api/v1/cards/pin', () => {});

  // Reset PIN
  this.post('/cards-api/v1/cards/list/pin/reset', () => resetPinSuccess);

  // Transfer Card
  this.post('/cards-api/v1/cards/transfer', () => {});

  // Update Card Usage
  this.post('/cards-api/v1/cards/:grandParentId/usage', () => {});

  // Update card status
  this.post('/cards-api/v1/cards/status', () => cardsStatusUpdate);

  // Update multiple card status
  this.post('/cards-api/v1/cards/list/status', () => cardsStatusUpdate);

  // Update single card details
  this.post('/cards-api/v1/cards/:grandParentId', () => cardEdit);

  // Update multi card details
  this.post('/cards-api/v1/cards/:grandParentId/update', () => cardEdit);

  // Cancel pending transfers batch
  this.delete('/cards-api/v1/cards/transfer/pending', () => {
  });

  // Update pending transfers batch
  this.put('/cards-api/v1/cards/transfer/pending', () => {
  });

  // Global Card Search (Cards)
  // this.get('/cards-api/v1/cards/search', () => cardSearch);

  // Global Card Search (Cash)
  this.get('/cards-api/v1/cards/search', () => cashSearch);
}
